import { Button, Form, Input } from "antd";
import Modal from "antd/es/modal/Modal";
import clsx from "clsx";
import { ReactNode, useState } from "react";
import { STATUS } from "src/constants";
import { Transaction } from "src/models/TransactionModel";
import { useCancelTranscationMutation } from "src/store/apis/Transactions";

export default function CancelModal({ record }: { record: Transaction }) {
  const [modalContent, setModalContent] = useState<ReactNode>(null);
  const [form] = Form.useForm();

  const [cancelTranscation, { isLoading: isLoadingCancel }] =
    useCancelTranscationMutation();

  const showModal = (action: string) => {
    if (action === "cancel") {
      setModalContent(
        <div>
          <h2 className="font-normal">
            Are you sure you want to cancel this transction{" "}
            <span className="font-semibold">{record.requestId}</span>?
          </h2>
        </div>,
      );
    }
  };

  const handelOK = (values: any) => {
    try {
      cancelTranscation(values).then(() => setModalContent(null));
    } catch (error) {
      console.error(error);
      setModalContent(null);
    }
  };

  const isDisabled = record?.transactionStatusId === STATUS.CANCELLED;

  return (
    <>
      <div className="flex justify-between gap-4">
        <Button
          disabled={isDisabled}
          className={clsx(
            "rounded-sm text-12 border-0 font-bold uppercase bg-primary text-white disabled:bg-gray-500",
          )}
          onClick={() => showModal("cancel")}
        >
          Cancel
        </Button>
      </div>
      <Modal
        className="custom-modal"
        title={modalContent}
        centered
        width={600}
        open={!!modalContent}
        footer={null}
        onCancel={() => setModalContent(null)}
      >
        <Form
          initialValues={{
            orderId: record?.siebelOrderId,
          }}
          onFinish={handelOK}
          form={form}
        >
          <Form.Item rules={[{ required: true }]} hidden name="orderId" />
          <Form.Item
            label="Reason"
            layout="vertical"
            name="reason"
            rules={[
              {
                validator: (_, value) => {
                  const arabicRegex = /[\u0600-\u06FF]/; // Matches any Arabic character
                  if (value && arabicRegex.test(value)) {
                    return Promise.reject(
                      new Error("Only English letters should be used"),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input />
          </Form.Item>
          <div className="mt-8 flex gap-4 justify-end">
            <Form.Item shouldUpdate>
              <Button
                htmlType="button"
                onClick={() => setModalContent(null)}
                className="border-solid border-1 text-16 font-medium inline-flex gap-2 items-center justify-center rounded-lg px-5 h-11"
              >
                Cancel
              </Button>
            </Form.Item>
            <Form.Item shouldUpdate>
              {({ getFieldError }) => {
                return (
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="disabled:bg-gray-400  bg-[#D14343] hover:bg-[#D4524D]  text-white text-16 font-medium inline-flex gap-2 items-center justify-center rounded-lg px-5 h-11"
                    disabled={
                      getFieldError("reason").length !== 0 || isLoadingCancel
                    }
                  >
                    {isLoadingCancel}
                    Confirm
                  </Button>
                );
              }}
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
}
